import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { Helmet } from "react-helmet-async";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import * as pdfjs from "pdfjs-dist/legacy/build/pdf";

import {
  ArrowLeft,
  Clock3,
  Download,
  Share2,
  ChevronRight,
  Phone,
  Mail,
  Globe,
  MessageCircle,
  ChevronDown,
  Menu,
  X,
} from "lucide-react";

import { motion } from "framer-motion";

import Navbar from "../New_Templates/Navbar";
import ApiService from "../Services/ApiServices";
import DemoForm from "../New_Templates/DemoForm";
import { IoIosArrowBack } from "react-icons/io";

import "./BlogDetail.css";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const BlogDetail = () => {
  const navigate = useNavigate();

  const { slug } = useParams();

  const blogId = Number(slug?.split("-").pop());

  const [blog, setBlog] = useState(null);

  const [loading, setLoading] = useState(true);

  const [contentTree, setContentTree] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [contactSection, setContactSection] = useState(null);
  const [showDemoModal, setShowDemoModal] = useState(false);

  console.log(blog, "demo")

  const [activeSection, setActiveSection] =
    useState("");

  const [scrollProgress, setScrollProgress] =
    useState(0);

  const [mobileTOC, setMobileTOC] =
    useState(false);

  const observerRef = useRef([]);

  useEffect(() => {
    fetchBlog();
  }, [blogId]);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      const progress =
        (window.scrollY / totalHeight) * 100;

      setScrollProgress(progress);
    };

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () =>
      window.removeEventListener(
        "scroll",
        handleScroll
      );
  }, []);

  const fetchBlog = async () => {
    try {
      const response = await ApiService.post(
        "blog/getBlogDetails",
        {}
      );

      if (response?.data) {
        const foundBlog = response.data.find(
          (item) =>
            Number(item.id) === blogId
        );

        setBlog(foundBlog || null);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!blog?.pdfFile) {
      setLoading(false);
      return;
    }

    loadPDF();
  }, [blog]);

  const loadPDF = async () => {
    try {
      const pdf = await pdfjs
        .getDocument(blog.pdfFile)
        .promise;

      let fullText = "";

      for (
        let pageNum = 1;
        pageNum <= pdf.numPages;
        pageNum++
      ) {
        const page =
          await pdf.getPage(pageNum);

        const textContent =
          await page.getTextContent();

        let lastY = null;
        let pageText = "";

        textContent.items.forEach(
          (item) => {
            const currentY =
              item.transform[5];

            // NEW LINE DETECTION
            if (
              lastY !== null &&
              Math.abs(
                currentY - lastY
              ) > 5
            ) {
              pageText += "\n";
            }

            pageText += item.str + " ";

            lastY = currentY;
          }
        );

        fullText += pageText + "\n\n";
      }

      const parsed =
        parseStructuredContent(
          fullText
        );

      console.log(
        parsed,
        "FINAL PARSED"
      );

      let extractedFaqs = [];
      let extractedContact =
        null;

      const filteredSections =
        parsed.filter((section) => {
          const title =
            section.title
              ?.toLowerCase()
              ?.trim() || "";

          // FAQ SECTION
          if (
            title.includes("faq") ||
            title.includes(
              "frequently asked"
            )
          ) {
            if (
              section.subsections
                ?.length > 0
            ) {
              extractedFaqs =
                section.subsections.map(
                  (sub) => ({
                    title: sub.title,

                    content:
                      sub.paragraphs?.join(
                        " "
                      ) || "",
                  })
                );
            }

            return false;
          }

          // CONTACT US SECTION
          if (
            title === "contact us" ||
            title.includes(
              "contact us"
            )
          ) {
            extractedContact =
              section;

            return false;
          }

          return true;
        });

      console.log(
        filteredSections,
        "FILTERED CONTENT"
      );

      console.log(
        extractedFaqs,
        "EXTRACTED FAQS"
      );

      console.log(
        extractedContact,
        "EXTRACTED CONTACT"
      );

      setFaqs(extractedFaqs);

      setContactSection(
        extractedContact
      );

      setContentTree(
        filteredSections
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const cleanPDFContent = (text) => {
    return text
      .replace(/\r/g, "\n")

      // FIX BROKEN WORDS FROM PDF
      .replace(/([a-zA-Z])\s-\s([a-zA-Z])/g, "$1-$2")
      .replace(/([a-z])\s{2,}([a-z])/g, "$1 $2")
      .replace(/([a-z])\n([a-z])/g, "$1 $2")

      // REMOVE EXTRA SPACES
      .replace(/[ \t]+/g, " ")

      // CLEAN MULTIPLE LINES
      .replace(/\n{3,}/g, "\n\n")

      .trim();
  };

  const splitIntoParagraphs = (text = "") => {
    return text
      .split(/\n\s*\n/g)
      .map((p) => p.trim())
      .filter((p) => p.length > 30);
  };

  const parseStructuredContent = (raw) => {
    const cleaned = cleanPDFContent(raw);

    const lines = cleaned
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);

    const sections = [];

    let currentSection = null;
    let currentSubsection = null;

    lines.forEach((line) => {
      // =========================
      // MAIN SECTION
      // =========================
      if (line.startsWith("## ")) {
        // PUSH PREVIOUS SUBSECTION
        if (currentSubsection && currentSection) {
          currentSection.subsections.push(
            currentSubsection
          );
        }

        // PUSH PREVIOUS SECTION
        if (currentSection) {
          sections.push(currentSection);
        }

        currentSection = {
          id: `section-${sections.length}`,
          title: line.replace("## ", "").trim(),
          paragraphs: [],
          subsections: [],
        };

        currentSubsection = null;

        return;
      }

      // =========================
      // SUBSECTION
      // =========================
      if (line.startsWith("### ")) {
        if (!currentSection) return;

        // PUSH OLD SUBSECTION
        if (currentSubsection) {
          currentSection.subsections.push(
            currentSubsection
          );
        }

        currentSubsection = {
          id: `section-${sections.length}-sub-${currentSection.subsections.length}`,
          title: line.replace("### ", "").trim(),
          paragraphs: [],
        };

        return;
      }

      // =========================
      // CONTENT
      // =========================
      if (currentSubsection) {
        currentSubsection.paragraphs.push(line);
      } else if (currentSection) {
        currentSection.paragraphs.push(line);
      }
    });

    // PUSH LAST SUBSECTION
    if (currentSubsection && currentSection) {
      currentSection.subsections.push(
        currentSubsection
      );
    }

    // PUSH LAST SECTION
    if (currentSection) {
      sections.push(currentSection);
    }

    // CLEAN PARAGRAPHS
    const finalSections = sections.map(
      (section) => ({
        ...section,

        paragraphs: splitIntoParagraphs(
          section.paragraphs.join("\n")
        ),

        subsections: section.subsections.map(
          (sub) => ({
            ...sub,

            paragraphs: splitIntoParagraphs(
              sub.paragraphs.join("\n")
            ),
          })
        ),
      })
    );

    return finalSections;
  };


  const formatParagraphs = (
    text
  ) => {
    if (!text) return [];

    return text
      .replace(/\s+/g, " ")
      .split(
        /(?<=\.)\s+(?=[A-Z])/
      )
      .map((p) => p.trim())
      .filter(
        (p) => p.length > 35
      );
  };

  const splitParagraphs = (text) => {
    return text
      .split(/\.\s+/g)
      .map((p) => p.trim())
      .filter(Boolean)
      .map((p) =>
        p.endsWith(".")
          ? p
          : p + "."
      );
  };

  useEffect(() => {
    const observer =
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (
              entry.isIntersecting
            ) {
              setActiveSection(
                entry.target.id
              );
            }
          });
        },
        {
          threshold: 0.25,
        }
      );

    observerRef.current.forEach(
      (section) => {
        if (section)
          observer.observe(section);
      }
    );

    return () => observer.disconnect();
  }, [contentTree, faqs]);

  const estimatedReadTime =
    useMemo(() => {
      const words = JSON.stringify(
        contentTree
      ).split(" ").length;

      return Math.max(
        5,
        Math.ceil(words / 220)
      );
    }, [contentTree]);

  const shareBlog = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: blog?.title,
          text: blog?.metaDescription,
          url: window.location.href,
        });
      } else {
        navigator.clipboard.writeText(
          window.location.href
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const downloadPDF = () => {
    const link =
      document.createElement("a");

    link.href = blog.pdfFile;

    link.download = `${blog.title}.pdf`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  if (!blog) {
    return (
      <div className="blog-empty">
        Blog not found
      </div>
    );
  }

  return (
    <>

      <Helmet>
        <title>
          {blog?.metaTitle ||
            blog?.title ||
            "Way4Track"}
        </title>

        <meta
          name="description"
          content={
            blog?.metaDescription || ""
          }
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content={
            blog?.metaTitle ||
            blog?.title ||
            "Way4Track"
          }
        />

        <meta
          property="og:description"
          content={
            blog?.metaDescription || ""
          }
        />

        <meta
          property="og:image"
          content={blog?.image || ""}
        />

        <meta
          property="og:type"
          content="article"
        />

        <meta
          property="og:url"
          content={window.location.href}
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content={
            blog?.metaTitle ||
            blog?.title ||
            "Way4Track"
          }
        />

        <meta
          name="twitter:description"
          content={
            blog?.metaDescription || ""
          }
        />

        <meta
          name="twitter:image"
          content={blog?.image || ""}
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href={window.location.href}
        />
      </Helmet>

      <div className="mobile-toc-toggle">
        <button
          // className="blog-back-btn"
          onClick={() =>
            navigate("/blogs")
          }
        >
          <ArrowLeft size={18} />
        </button>

        <button
          onClick={() =>
            setMobileTOC(
              !mobileTOC
            )
          }
        >
          {mobileTOC ? (
            <X size={18} />
          ) : (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              {/* <p>Blog Contents</p> */}
              <Menu size={18} />
              {/* <IoIosArrowBack  size={18} /> */}

            </div>
          )}
        </button>

      </div>
      <div className="blog-page-container">
        <>

          {/* PROGRESS */}
          <div className="blog-progress-wrap">
            <motion.div
              className="blog-progress-bar"
              animate={{
                width: `${scrollProgress}%`,
              }}
            />
          </div>

          {mobileTOC && (
            <div
              className="mobile-sidebar-overlay"
              onClick={() => setMobileTOC(false)}
            />
          )}

          {/* LAYOUT */}
          <div className="blog-layout">


            {/* SIDEBAR */}
            <aside
              className={`blog-sidebar ${mobileTOC
                ? "show-mobile-sidebar"
                : ""
                }`}
            >

              {/* <div className="blog-floating-header"> */}
              <div className="blog-back-btn-container">
                <button
                  className="blog-back-btn"
                  onClick={() =>
                    navigate("/blogs")
                  }
                >
                  <ArrowLeft size={16} />
                  Back
                </button>
              </div>
              {/* </div> */}

              <div className="blog-sidebar-card">
                <div className="toc-top">

                  <span>
                    CONTENTS
                  </span>

                  <h3>
                    Table of Contents
                  </h3>
                </div>

                <div className="blog-sidebar-links">
                  {contentTree.map(
                    (
                      section,
                      index
                    ) => (
                      <a
                        key={index}
                        href={`#${section.id}`}
                        className={
                          activeSection ===
                            section.id
                            ? "active"
                            : ""
                        }
                        onClick={() => setMobileTOC(false)}
                      >
                        <ChevronRight
                          size={14}
                        />

                        <span>
                          {
                            section.title
                          }
                        </span>
                      </a>
                    )
                  )}
                  {/* SUPPORT LINK */}
                  <a
                    href="#support-section"
                    className={
                      activeSection ===
                        "support-section"
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      setMobileTOC(false)
                    }
                  >
                    <ChevronRight size={14} />

                    <span>
                      Support
                    </span>
                  </a>

                  <a
                    href="#faq-section"
                    className={
                      activeSection ===
                        "faq-section"
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      setMobileTOC(false)
                    }

                  >
                    <ChevronRight size={14} />

                    <span>
                      FAQs
                    </span>
                  </a>


                </div>
              </div>
            </aside>

            {/* MAIN */}
            <main className="blog-main">
              {/* HERO */}
              <section className="blog-hero">
                <div className="blog-hero-image-wrap">
                  <motion.img
                    src={blog.image}
                    alt={blog.title}
                    className="blog-hero-image"
                    initial={{
                      scale: 1.08,
                    }}
                    animate={{
                      scale: 1,
                    }}
                    transition={{
                      duration: 1.2,
                    }}
                  />

                  <div className="blog-overlay" />
                </div>
              </section>

              {/* FLOATING TOP BAR */}
              <div className="blog-section-actions-container">
                <div className="blog-floating-left">
                  <div className="blog-category-row">
                    <span>
                      GPS Tracking
                    </span>

                    <span>AIS-140</span>

                    <span>
                      Fleet Intelligence
                    </span>
                  </div>
                </div>

                <div className="blog-meta-right">
                  <div className="blog-readtime">
                    <Clock3 size={15} />
                    {
                      estimatedReadTime
                    }{" "}
                    min read
                  </div>

                  <button
                    onClick={shareBlog}
                  >
                    <Share2 size={16} />
                  </button>

                  <button
                    onClick={downloadPDF}
                  >
                    <Download size={16} />
                  </button>
                </div>
              </div>

              {loading ? (
                <div className="blog-loader-wrap">
                  <div className="blog-loader" />
                </div>
              ) : (
                <>
                  {contentTree.map(
                    (
                      section,
                      index
                    ) => (
                      <motion.section
                        key={index}
                        id={section.id}
                        ref={(el) =>
                        (observerRef.current[
                          index
                        ] = el)
                        }
                        className="blog-section"
                        initial={{
                          opacity: 0,
                          y: 30,
                        }}
                        whileInView={{
                          opacity: 1,
                          y: 0,
                        }}
                        viewport={{
                          once: true,
                        }}
                        transition={{
                          duration: 0.5,
                        }}
                      >

                        <div className="blog-section-heading">
                          <span>
                            WAY4TRACK
                            INSIGHTS
                          </span>

                          <h2>
                            {
                              section.title
                            }
                          </h2>
                        </div>

                        <div className="blog-section-content">
                          {section.paragraphs.map(
                            (
                              paragraph,
                              pIndex
                            ) => (
                              <p
                                key={
                                  pIndex
                                }
                                className="blog-paragraph"
                              >
                                {
                                  paragraph
                                }
                              </p>
                            )
                          )}
                        </div>

                        {section
                          .subsections
                          ?.length >
                          0 && (
                            <div className="blog-subsections">
                              {section.subsections.map(
                                (
                                  sub,
                                  sIndex
                                ) => (
                                  <motion.div
                                    key={
                                      sIndex
                                    }
                                    className="blog-subsection"
                                    initial={{
                                      opacity: 0,
                                      y: 20,
                                    }}
                                    whileInView={{
                                      opacity: 1,
                                      y: 0,
                                    }}
                                    viewport={{
                                      once: true,
                                    }}
                                  >
                                    <div className="blog-subsection-top">
                                      <div className="blog-sub-line" />

                                      <h3>
                                        {
                                          sub.title
                                        }
                                      </h3>
                                    </div>

                                    <div className="blog-subsection-content">
                                      {sub.paragraphs.map(
                                        (
                                          para,
                                          i
                                        ) => (
                                          <p
                                            key={
                                              i
                                            }
                                            className="blog-sub-para"
                                          >
                                            {
                                              para
                                            }
                                          </p>
                                        )
                                      )}
                                    </div>
                                  </motion.div>
                                )
                              )}
                            </div>
                          )}
                      </motion.section>
                    )
                  )}

                  <section
                    id="support-section"
                    ref={(el) =>
                    (observerRef.current[
                      contentTree.length + 1
                    ] = el)
                    }
                    className="blog-section"
                  >
                    <div className="blog-support-left">
                      <span>
                        TALK TO OUR TEAM
                      </span>

                      <h2>
                        Need Help Choosing
                        the Right GPS
                        Tracking Solution?
                      </h2>

                      <p>
                        {contactSection?.paragraphs?.[0]}
                      </p>

                      <div className="blog-support-buttons">
                        <button onClick={() => setShowDemoModal(true)}>
                          {/* Talk to Expert */}
                          Schedule Demo
                        </button>

                        {/* <button className="outline-btn">
                          Schedule Demo
                        </button> */}
                      </div>
                    </div>

                    <div className="blog-support-cards">
                      <div className="support-card">
                        <Phone size={20} />

                        <h4>Call Us</h4>

                        <a
                          href="tel:+917032213434"
                          className="support-link"
                        >
                          +91 7032 213 434
                        </a>
                      </div>

                      <div className="support-card">
                        <Mail size={20} />

                        <h4>Email</h4>

                        <a
                          href="mailto:support@way4track.com"
                          className="support-link"
                        >
                          support@way4track.com
                        </a>
                      </div>

                      <div className="support-card">
                        <Globe size={20} />

                        <h4>Website</h4>

                        <a
                          href="https://www.way4track.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="support-link"
                        >
                          www.way4track.com
                        </a>
                      </div>

                      <div className="support-card">
                        <MessageCircle size={20} />

                        <h4>WhatsApp</h4>

                        <a
                          href={`https://wa.me/917032213434?text=${encodeURIComponent(
                            "Hello Way4Track Team, I'm interested in your GPS tracking solutions. Please share more details."
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="support-link"
                        >
                          Chat with our Expert
                        </a>
                      </div>
                    </div>
                  </section>

                  {showDemoModal && (
                    <DemoForm onClose={() => setShowDemoModal(false)} />
                  )}

                  {/* FAQ */}
                  <section
                    id="faq-section"
                    ref={(el) =>
                    (observerRef.current[
                      contentTree.length
                    ] = el)
                    }
                    className="blog-section"
                  >
                    <div className="blog-section-heading">
                      <span>
                        SUPPORT
                      </span>

                      <h2>
                        Frequently Asked
                        Questions
                      </h2>
                    </div>

                    {faqs?.map(
                      (faq, index) => (
                        <FAQItem
                          key={index}
                          title={faq.title}
                          content={faq.content}
                        />
                      )
                    )}
                  </section>

                </>
              )}
            </main>
          </div>
        </>
      </div>
    </>
  );
};

const FAQItem = ({
  title,
  content,
}) => {
  const [open, setOpen] =
    useState(false);

  return (
    <div
      className={`faq-item ${open ? "open" : ""
        }`}
    >
      <button
        className="faq-header"
        onClick={() =>
          setOpen(!open)
        }
      >
        <h4>{title}</h4>

        <ChevronDown size={18} />
      </button>

      <motion.div
        initial={false}
        animate={{
          height: open
            ? "auto"
            : 0,
          opacity: open ? 1 : 0,
        }}
        className="faq-body"
      >
        <p>{content}</p>
      </motion.div>
    </div>
  );
};

export default BlogDetail;